import React from 'react';
import { withFormsy } from 'formsy-react';
import { TextField, FormHelperText } from '@mui/material';

class TextInput extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.value) {
      this.props.setValue(this.props.value);
    }
    this.changeValue = this.changeValue.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  changeValue(event) {
    const { onChange, setValue } = this.props;
    if (onChange) onChange(event);
    setValue(event.target.value);
  }

  handleOnBlur(event) {
    const { onBlur } = this.props;
    if (onBlur) onBlur(event);
  }

  render() {
    const { type, name, label, required, disabled, multiline, inputLabelProps, inputFieldProps, value, hint, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className={'input-container text-field' + (type == 'hidden' ? ' hidden' : '')}>
        <TextField
          variant="standard"
          error={isError}
          type={type || "text"}
          required={required}
          multiline={multiline}
          rows={multiline ? 4 : undefined}
          id={name}
          name={name}
          label={label}
          onChange={this.changeValue}
          onBlur={this.handleOnBlur}
          value={value || ''}
          disabled={disabled}
          fullWidth
          InputLabelProps={inputLabelProps}
          inputProps={{
            ...inputFieldProps,
            'aria-describedby': isError ? `${name}_error` : undefined,
          }}
        />

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText id={`${name}_error`} error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(TextInput);
